@use '@design/design-tokens/border-radius/border-radius' as *;

.legendPriceIconsRoot {
  display: flex;
  align-items: center;
  border: 1px solid var(--border-soft);
  padding: 2px;
  gap: 2px;
  @include border-radius-r1;
}

.iconSpan {
  display: flex;
  gap: 2px;
}
